var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2238",
    "data-name": "Rectangle 2238",
    width: 35,
    height: 35,
    transform: "translate(0 0)",
    fill: "#ffe800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10217",
    "data-name": "Group 10217",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10216",
    "data-name": "Group 10216",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27578",
    "data-name": "Path 27578",
    d: "M32.6,18.121l-9.951-6.346L23,6.788a4.135,4.135,0,0,0-.684-2.6L20.742,1.84a4.135,4.135,0,0,0-6.879,0L12.287,4.2A4.235,4.235,0,0,0,11.6,6.8l.369,4.987L2.021,18.121A4.316,4.316,0,0,0,0,21.77v2.741a1.442,1.442,0,0,0,1.442,1.442,1.289,1.289,0,0,0,.375-.052L12.76,22.928l.173,2.478L9.92,28.416a4.273,4.273,0,0,0-1.269,3.057v1.69a1.441,1.441,0,0,0,1.726,1.411l6.917-1.38,6.925,1.38a1.42,1.42,0,0,0,1.2-.292,1.436,1.436,0,0,0,.533-1.119v-1.69a4.287,4.287,0,0,0-1.269-3.057L21.672,25.4l.173-2.478L32.788,25.9a1.289,1.289,0,0,0,.375.052A1.442,1.442,0,0,0,34.6,24.512V21.77A4.324,4.324,0,0,0,32.6,18.121M2.884,22.62v-.85a1.434,1.434,0,0,1,.677-1.217l8.636-5.5.344,4.941Zm19.765,7.832a1.5,1.5,0,0,1,.421.954l-5.483-1.1a1.39,1.39,0,0,0-.563,0l-5.489,1.1a1.429,1.429,0,0,1,.421-.954l3.484-3.478a1.445,1.445,0,0,0,.421-1.127L14.892,12.3v-.013l-.406-5.7a1.255,1.255,0,0,1,.2-.788l1.576-2.359a1.293,1.293,0,0,1,2.08,0L19.915,5.8a1.237,1.237,0,0,1,.211.788l-.406,5.7V12.3l-.977,13.548a1.429,1.429,0,0,0,.421,1.127Zm9.072-7.832-9.657-2.63.344-4.941,8.643,5.5a1.444,1.444,0,0,1,.669,1.217Z",
    transform: "translate(0 0.001)",
    fill: "#ffe800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon18);
export default __webpack_public_path__ + "static/media/social_icon18.20234a98a5c10e8d46a75f3f6c114d0d.svg";
export { ForwardRef as ReactComponent };